export interface ChecklistItem {
  id: string
  text: string
}

export const hygieneChecklistItems: ChecklistItem[] = [
  { id: 'brush-teeth', text: 'Did you brush your teeth in the morning and evening?' },
  { id: 'gums', text: 'Did you take care of your gums, including flossing and or using mouthwash?' },
  { id: 'bathe', text: 'Did you bathe today? And did you use soap to clean your body? And Shampoo your hair?' },
  { id: 'clean-clothes', text: 'Did you get dressed in clean clothes when you got got up?' },
  { id: 'wash-hands', text: 'Did you wash your hands regularly, especially before meals and after using the restroom?' },
  { id: 'fart', text: 'Do you fart in public? Everyone does it, but try to excuse yourself to a private area if possible.' },
  {
    id: 'nose-pick',
    text: 'Do you pick your nose in public? Everyone picks their nose. Nobody wants to see you doing it. Do it in the bathroom, and wash your hands afterward.',
  },
  {
    id: 'cover-cough',
    text: 'Do you cover your mouth when you cough or sneeze? It helps prevent the spread of germs and shows consideration for others.',
  },
]

export const timeManagementChecklistItems: ChecklistItem[] = [
  { id: 'wake-up-time', text: 'Did you wake up and go to bed at consistent times today? On Your Own.' },
  { id: 'plan-day', text: 'Did you plan out your day, either with a to-do list or a schedule?' },
  { id: 'prioritize', text: 'Did you tackle your most important task before getting distracted by smaller ones?' },
  { id: 'avoid-procrastination', text: 'Did you get started on the tasks you knew needed to be done today, instead of putting them off?' },
  { id: 'set-deadlines', text: 'Did you set realistic deadlines for the tasks you started?' },
  { id: 'limit-distractions', text: 'Did you limit distractions like your phone, friends, or TV until your tasks were completed?' },
  { id: 'plan-free-time', text: 'Did you plan your free time and relaxation for after your tasks were done, instead of before?' },
  { id: 'review-day', text: 'Did you review what you got done today and adjust your plan for tomorrow?' },
]

export const communicationSkillsChecklistItems: ChecklistItem[] = [
  { id: 'listen-fully', text: 'Did you listen to what someone was saying without interrupting or planning your response?' },
  { id: 'eye-contact', text: 'Did you make eye contact when talking to someone, showing you are paying attention?' },
  { id: 'nod-acknowledge', text: 'Did you nod and give verbal responses like "I see" or "That makes sense" to show you were listening?' },
  { id: 'ask-questions', text: 'Did you ask follow-up questions to understand someone better, instead of making assumptions?' },
  {
    id: 'remember-details',
    text: 'Did you remember specific details from what they told you and bring them up later to show you were really listening?',
  },
  { id: 'apologize', text: "Did you apologize sincerely if you made a mistake or hurt someone's feelings?" },
  { id: 'tone-respectful', text: 'Did you speak respectfully, even when you disagreed with someone?' },
  { id: 'body-language', text: 'Did you pay attention to your body language and avoid crossing your arms or looking away?' },
]

export const responsibilityChecklistItems: ChecklistItem[] = [
  { id: 'work-on-time', text: 'Did you show up on time to work or school and fulfill your job responsibilities?' },
  { id: 'work-tasks', text: 'Did you complete the tasks your boss, parent, or teacher assigned you?' },
  { id: 'chores-done', text: 'Did you complete your household chores without being asked multiple times?' },
  { id: 'chores-quality', text: 'Did you do your chores or work properly, not just rush through them?' },
  { id: 'homework-done', text: 'Did you complete your work tasks or schoolwork for the day?' },
  { id: 'school-attend', text: 'Did you attend your job, or classes and pay attention?' },
  { id: 'admit-mistakes', text: 'If you made a mistake at work, school, or home, did you admit it instead of blaming others?' },
  { id: 'follow-through', text: 'Did you follow through on promises and commitments you made to others?' },
]

export const emotionalIntelligenceChecklistItems: ChecklistItem[] = [
  { id: 'recognize-feelings', text: 'Did you take time to recognize what you were feeling today, even if it was uncomfortable?' },
  { id: 'manage-anger', text: 'When you felt angry or frustrated, did you pause before reacting instead of lashing out?' },
  { id: 'empathy', text: 'Did you try to understand how someone else was feeling and why they might have acted the way they did?' },
  {
    id: 'read-cues',
    text: 'Did you notice non-verbal cues like body language or tone of voice to understand how others were really feeling?',
  },
  { id: 'express-feelings', text: 'Did you express your feelings in a respectful way instead of shutting down or being aggressive?' },
  { id: 'handle-feedback', text: 'If someone gave you criticism or feedback, did you listen without getting defensive?' },
  { id: 'comfort-others', text: 'Did you help comfort or support someone who was struggling emotionally?' },
  {
    id: 'respect-boundaries',
    text: "Did you respect other people's boundaries and personal space, even when you wanted to talk or be close to them?",
  },
  { id: 'self-aware', text: 'Did you notice how your mood or emotions affected your behavior and how others responded to you?' },
]

export const problemSolvingChecklistItems: ChecklistItem[] = [
  { id: 'identify-problem', text: 'Did you clearly identify what the actual problem was, not just the symptom?' },
  { id: 'break-down', text: 'Did you break the problem down into smaller, more manageable parts?' },
  { id: 'brainstorm-solutions', text: 'Did you brainstorm at least two or three possible solutions before choosing one?' },
  { id: 'think-consequences', text: 'Before acting, did you think about the possible consequences of your solutions?' },
  { id: 'ask-help', text: 'Did you know when to ask for help instead of trying to solve everything alone?' },
  { id: 'try-solution', text: 'Did you try one solution and see if it actually worked before moving to the next one?' },
  { id: 'learn-mistake', text: "If your solution didn't work, did you figure out what went wrong and try a different approach?" },
  { id: 'stay-calm', text: 'Did you stay calm and think clearly, even when the problem was frustrating or stressful?' },
]

export const financialLiteracyChecklistItems: ChecklistItem[] = [
  { id: 'track-spending', text: 'Did you keep track of how much money you spent today or this week?' },
  { id: 'budget', text: 'Did you create or stick to a budget that tracks your income and expenses?' },
  { id: 'save-money', text: 'Did you put money aside for savings instead of spending everything you earn?' },
  { id: 'needs-vs-wants', text: 'Did you think about the difference between what you need and what you want before spending?' },
  { id: 'avoid-debt', text: "Did you avoid borrowing money you don't need or spending money you don't have?" },
  { id: 'research-big-purchase', text: 'Before making a big purchase, did you compare options or wait before buying?' },
  { id: 'understand-costs', text: 'Did you understand the full cost of something before committing to it (taxes, fees, interest, etc.)?' },
  { id: 'emergency-fund', text: 'Are you working toward building an emergency fund for unexpected expenses?' },
]

export const householdCareChecklistItems: ChecklistItem[] = [
  { id: 'clean-room', text: 'Did you clean and organize your personal space?' },
  { id: 'dirty-clothes', text: 'Did you put your dirty clothes in a hamper instead of leaving them on the floor?' },
  { id: 'dishes', text: 'Did you wash dishes or put them in the dishwasher after eating?' },
  { id: 'laundry', text: 'Did you do your laundry and put clean clothes away properly?' },
  { id: 'vacuum-sweep', text: 'Did you vacuum, sweep, or clean common areas in your home?' },
  { id: 'trash', text: 'Did you take out the trash when it got full?' },
  { id: 'clutter', text: 'Did you pick up clutter and put things back where they belong?' },
  { id: 'bathroom', text: 'Did you keep the bathroom clean and organized?' },
  { id: 'maintain-home', text: 'Did you help maintain your home by noticing things that need fixing and reporting them?' },
]

export const friendsAndFamilyChecklistItems: ChecklistItem[] = [
  { id: 'show-up', text: 'Did you show up or keep plans you made with friends or family?' },
  { id: 'listen-them', text: 'Did you listen to what friends or family members had to say, not just wait for your turn to talk?' },
  { id: 'support-them', text: 'Did you support someone when they were struggling or going through something hard?' },
  { id: 'honest', text: 'Were you honest with people you care about, even when it was uncomfortable?' },
  { id: 'respect-time', text: 'Did you respect their time and space, or did you demand all their attention?' },
  { id: 'apologize', text: 'If you hurt someone, did you apologize sincerely and commit to not doing it again?' },
  { id: 'celebrate-wins', text: 'Did you celebrate with friends or family when something good happened to them?' },
  {
    id: 'maintain-connection',
    text: 'Did you reach out or spend time with people who matter to you, or did you only show up when you needed something?',
  },
]

export const likeLoveLustChecklistItems: ChecklistItem[] = [
  { id: 'understand-feelings', text: 'Did you take time to understand your own feelings before acting on them?' },
  { id: 'know-difference', text: 'Did you distinguish between liking someone, being infatuated, and being in love?' },
  { id: 'healthy-interest', text: 'Did you pursue someone in a healthy way that respects their boundaries and choices?' },
  { id: 'no-obsession', text: 'Did you avoid becoming obsessed with someone or losing yourself in a relationship?' },
  { id: 'communicate', text: 'Did you communicate clearly about what you want instead of playing games or being unclear?' },
  { id: 'respect-no', text: 'If someone wasn\'t interested, did you respect their "no" and move on?' },
  {
    id: 'evaluate-partner',
    text: 'Did you think about whether this person is actually right for you, not just what you feel in the moment?',
  },
  {
    id: 'independent',
    text: 'Did you maintain your own identity, interests, and friendships instead of merging your whole life with someone?',
  },
]

export const spiritualAwarenessChecklistItems: ChecklistItem[] = [
  { id: 'reflect', text: 'Did you take time to reflect on who you are and what matters to you? Do you know your core values?' },
  { id: 'values', text: 'Did you consider your core values and whether your actions aligned with them?' },
  { id: 'purpose', text: 'Did you think about your purpose or what gives your life meaning? What makes you feel at peace?' },
  { id: 'mindfulness', text: 'Did you practice being present and aware, rather than rushing through the day?' },
  { id: 'gratitude', text: 'Did you notice something to be grateful for, even if things were difficult?' },
  { id: 'forgive', text: 'Did you work on forgiving yourself or others for mistakes?' },
  { id: 'connection', text: 'Did you feel connected to something larger than yourself (nature, community, faith, etc.)?' },
  { id: 'growth', text: 'Did you learn something about yourself that will help you grow as a person? Did it strengthen your core values?' },
]
